{
  "close": "إغلاق"
}
